import { Tabs, Tab, Container, Paper } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const ALL_TABS = [
  { path: '/payroll', label: 'Generate Pay', permission: 'payroll.generate' },
  { path: '/payroll/salary-config', label: 'Configure Salary', permission: 'payroll.configure_salary' },
  { path: '/payroll/notes', label: 'Notes', permission: 'payroll.notes' },
];

function PayrollTabs() {
  const location = useLocation();
  const navigate = useNavigate();
  const { hasPermission } = useAuth();
  const TABS = ALL_TABS.filter((t) => hasPermission(t.permission));
  const activeIndex = TABS.findIndex((tab) => tab.path === location.pathname);

  return (
    <Container maxWidth="xl" sx={{ mt: 3 }}>
      <Paper>
        <Tabs
          value={activeIndex === -1 ? 0 : activeIndex}
          onChange={(e, newValue) => navigate(TABS[newValue].path)}
          variant="scrollable"
          scrollButtons="auto"
        >
          {TABS.map((tab) => (
            <Tab key={tab.path} label={tab.label} />
          ))}
        </Tabs>
      </Paper>
    </Container>
  );
}

export default PayrollTabs;
